import { useEffect } from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { Searchbar } from '../../search/components/Searchbar'
import { CapoLogo } from '../../theme/components/CapoLogo'
import { DspLogo } from '../../theme/components/DspLogo'
import { usePageInfo } from '../../theme/hooks/usePageInfo'

import { DomainCard } from './DomainCard'

export { DomainSelector }

interface Props {
  canViewProjecten: boolean
  canViewOpdrachten: boolean
  canViewHoofdnetOpdrachten: boolean
}

const DomainSelector = ({
  canViewProjecten,
  canViewOpdrachten,
  canViewHoofdnetOpdrachten,
}: Props) => {
  const { setBreadcrumbs } = usePageInfo()

  useEffect(() => {
    setBreadcrumbs([])
  }, [setBreadcrumbs])

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 6,
        height: '100%',
        maxHeight: '80%',
        maxWidth: '1240px', // max 4 tiles wide
        width: '100%',
        margin: '0 auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography variant="h2" sx={{ margin: 0 }}>
          Welkom bij CAPO
        </Typography>
        <Typography variant="h4">Selecteer een domein</Typography>
      </Box>

      <Box
        sx={{
          gap: 5,
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          flexWrap: 'wrap', // container too small? use next row
        }}
      >
        {canViewProjecten && (
          <>
            <DomainCard
              title="CAPO Aansluiting"
              to="/aansluiting/projecten"
              index={0}
            >
              <CapoLogo />
            </DomainCard>

            <DomainCard
              title="CAPO Hoofdleiding"
              to="/hoofdleiding/projecten"
              index={1}
            >
              <CapoLogo />
            </DomainCard>
          </>
        )}

        {canViewOpdrachten && (
          <DomainCard title="DSP Opdrachten" to="/opdrachten" index={2}>
            <DspLogo />
          </DomainCard>
        )}

        {canViewHoofdnetOpdrachten && (
          <DomainCard title="DSP Hoofdnet" to="/hoofdnetopdrachten" index={3}>
            <DspLogo />
          </DomainCard>
        )}

        {!canViewProjecten &&
          !canViewOpdrachten &&
          !canViewHoofdnetOpdrachten && (
            <Typography>
              We hebben geen domein kunnen bepalen. Gebruik het menu om te
              navigeren.
            </Typography>
          )}
      </Box>

      {canViewProjecten && <Searchbar />}
    </Box>
  )
}
